(function() {
  const accordions = document.querySelectorAll('.main-product-ingredients [data-accordion]');
  const ANIMATION_DURATION = 250;
  
  // Expand the first accordion by default
  if (accordions.length > 0) {
    accordions[0].classList.add('is-expanded');
  }

  function openAccordion(accordion) {
    accordion.classList.add('is-expanded');
  }

  function closeAccordion(accordion) {
    accordion.classList.add('is-closing');
    accordion.classList.remove('is-expanded');
    
    setTimeout(() => {
      accordion.classList.remove('is-closing');
    }, ANIMATION_DURATION);
  }

  accordions.forEach(accordion => {
    const title = accordion.querySelector('.main-product-ingredients--block-title');

    // Click anywhere on closed accordion to open
    accordion.addEventListener('click', (e) => {
      const isCurrentlyExpanded = accordion.classList.contains('is-expanded');
      const isClosing = accordion.classList.contains('is-closing');
      if (isCurrentlyExpanded || isClosing) return;
      openAccordion(accordion);
    });

    // Click title to close when expanded
    if (title) {
      title.addEventListener('click', (e) => {
        const isCurrentlyExpanded = accordion.classList.contains('is-expanded');
        const isClosing = accordion.classList.contains('is-closing');
        if (isCurrentlyExpanded && !isClosing) {
          e.stopPropagation();
          closeAccordion(accordion);
        }
      });
    }
  });
})();